module.exports = __webpack_public_path__ + "img/favicon.b7d251a.png";